import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.css']
})
export class InstructionsComponent implements OnInit, OnChanges {

  @Input() name: any;
public instructiontext : string = "";
primaryColor?: string = "";
  safeHtml: SafeHtml | null = null;
  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.name) {
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.name);
    }
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      const val = changes['name'].currentValue;
      this.safeHtml = val ? this.sanitizer.bypassSecurityTrustHtml(val) : null;
    }
  }

  private findSmartBreakY(canvas: HTMLCanvasElement, startY: number, targetEndY: number): number {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return targetEndY;
    }

    const scanPadding = 40;
    const minScanY = Math.max(startY + 80, targetEndY - scanPadding);
    const maxScanY = Math.min(canvas.height - 1, targetEndY + scanPadding);
    const width = canvas.width;

    const rowHasContent = (y: number): boolean => {
      const row = ctx.getImageData(0, y, width, 1).data;
      for (let i = 0; i < row.length; i += 4) {
        const r = row[i];
        const g = row[i + 1];
        const b = row[i + 2];
        const a = row[i + 3];
        // Treat near-white transparent rows as empty.
        if (a > 10 && (r < 245 || g < 245 || b < 245)) {
          return true;
        }
      }
      return false;
    };

    for (let y = targetEndY; y >= minScanY; y--) {
      if (!rowHasContent(y)) {
        return y;
      }
    }

    for (let y = targetEndY + 1; y <= maxScanY; y++) {
      if (!rowHasContent(y)) {
        return y;
      }
    }

    return targetEndY;
  }

  exportAsPDF(divId: any) {
    const data = document.getElementById(divId);
    if (!data) {
      alert('Content not found!');
      return;
    }

    html2canvas(data, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: data.scrollWidth,
      windowHeight: data.scrollHeight,
      backgroundColor: '#ffffff',
      onclone: (_doc: Document, el: HTMLElement) => {
        // Remove overflow/height restrictions so the full content is captured
        el.style.overflow = 'visible';
        el.style.height = 'auto';
        el.style.maxHeight = 'none';
        el.style.display = 'block';
        // Also fix parent modal-body scroll container
        const parent = el.parentElement;
        if (parent) {
          parent.style.overflow = 'visible';
          parent.style.height = 'auto';
          parent.style.maxHeight = 'none';
        }
      }
    }).then((canvas) => {
      const pdf = new jspdf('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const contentWidth = pdfWidth - margin * 2;
      const pageContentHeight = pdfHeight - margin * 2;

      const mmPerPx = contentWidth / canvas.width;
      const pageHeightPx = Math.floor(pageContentHeight / mmPerPx);
      let sourceY = 0;
      let pageIndex = 0;

      while (sourceY < canvas.height) {
        const defaultEndY = Math.min(sourceY + pageHeightPx, canvas.height);
        const smartEndY = defaultEndY < canvas.height
          ? this.findSmartBreakY(canvas, sourceY, defaultEndY)
          : defaultEndY;
        const sliceHeightPx = Math.max(1, smartEndY - sourceY);
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeightPx;

        const ctx = pageCanvas.getContext('2d');
        if (!ctx) {
          alert('Failed to generate PDF content.');
          return;
        }

        ctx.drawImage(
          canvas,
          0,
          sourceY,
          canvas.width,
          sliceHeightPx,
          0,
          0,
          canvas.width,
          sliceHeightPx
        );

        const imgData = pageCanvas.toDataURL('image/png');
        const renderedHeight = sliceHeightPx * mmPerPx;
        if (pageIndex > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'PNG', margin, margin, contentWidth, renderedHeight);

        sourceY += sliceHeightPx;
        pageIndex += 1;
      }

      pdf.save('instructions.pdf');
    });
  }

}
